import React from 'react';
import { parseISO, addBusinessDays } from 'date-fns';
import PropTypes from 'prop-types';

import { DateCell } from 'libs/connection/cells/Date';

export const DeliveryDateCell = ({ order }) => {
  const { quote } = order;
  const manuPlusShippingTime =
    quote.for.leadTime + quote.shippingQuote.deliveryTime;
  const createdAtDate = parseISO(order.createdAt);
  const estDeliveryDate = addBusinessDays(createdAtDate, manuPlusShippingTime);

  return <>{DateCell(estDeliveryDate)}</>;
};

DeliveryDateCell.propTypes = {
  order: PropTypes.object,
};
